/* eslint-disable max-len */
import { StoreState, VoidCallback } from '@deqo/foundation';
import React from 'react';
import Scrollbars from 'react-custom-scrollbars';
import styled from 'styled-components';
import { useWindowSizeInRem } from '../../../platform/Hook';
import { FixedScroller } from '../../../ui/Scrollers';
import { Avatar } from '../../common/Avatar';
import { Flexer } from '../../dashboard/elements/LayoutElements';
import { Participant } from '../participants/Participant';
import { Colors, Menu } from './../../../ui';
import { ParticipantActionMenu } from './ParticipantActionMenu';

const XScrollbars = Scrollbars as any;

const ParticipantLabel = styled.span`
    margin-left: .5rem;
`;

const ParticipantStatus = styled.span`
    margin-left: .5rem;
    margin-top: -.125rem;
    color: ${Colors.textLight};
    font-size: 0.8125rem;
`;

const ParticipantItem = React.memo(({ participant, onAction, }: { participant: StoreState<Participant>, onAction: VoidCallback }) => {

    return <Menu.SubMenuItem
        placement="left"
        inner={{ direction: 'left', offset: '.5' }}
        content={<ParticipantActionMenu participant={participant} onAction={onAction} />}>
        <Flexer padding="0 2 0 0" opacity={participant.presence === 'offline' ? .5 : 1} flex="row" center gap=".25">
            <Avatar.ForUser size="1.5" user={participant} />
            <Menu.ItemTextCropped>
                <Flexer flex="column">
                    <ParticipantLabel>{participant.name}</ParticipantLabel>
                    <ParticipantStatus>{participant.presence === 'offline' ? 'offline' : 'online'}</ParticipantStatus>
                </Flexer>
            </Menu.ItemTextCropped>
        </Flexer>
    </Menu.SubMenuItem>;
});

export const ParticipantListMenu = React.memo(({ items, onAction, }: { items: StoreState<Participant>[], onAction: VoidCallback }) => {

    const { height } = useWindowSizeInRem();
    const maxHeight = Math.min(height - 4, height * .5);

    return <FixedScroller maxHeight={maxHeight}>
        <Menu>
            <Menu.Section first title="Everyone Else">
                {items.map(x => <ParticipantItem key={x.id} participant={x} onAction={onAction} />)}
            </Menu.Section>
        </Menu>
    </FixedScroller>;
});
